import dayjs from "dayjs";

import { AccountNameCell } from "app/components/React/Table/cells/AccountNameCell/AccountNameCell";
import { column } from "app/components/React/Table/SWReactTableDefaults";

export const tableColumns = [
    column({
        field: "AccountId",
        trackingName: "AccountId",
        displayName: "Account ID",
        cellTemplate: "default-cell",
        width: "120px",
    }),
    column({
        field: "Email",
        trackingName: "Email",
        displayName: "Email",
        tooltip: "User email",
        cellTemplate: "link-impersonate",
        cellClass: "impersonateCell",
        minWidth: 200,
    }),
    column({
        field: "Role",
        trackingName: "Role",
        displayName: "Role",
        tooltip: "Role",
        cellTemplate: "default-cell",
        width: "100px",
    }),
    column({
        field: "AccountName",
        trackingName: "AccountName",
        displayName: "Account Name",
        tooltip: "AccountName",
        cellComponent: AccountNameCell,
        width: "150px",
    }),
    column({
        field: "LastAccess",
        trackingName: "LastAccess",
        displayName: "Last Login",
        cellTemplate: "default-cell",
        width: "150px",
        cellComponent: ({ value }) => {
            if (!value || value === "") {
                return <span>-</span>;
            }
            return <span>{dayjs(value as string).format("DD MMM, YYYY")}</span>;
        },
    }),
];

export const DEFAULT_SEARCH_IN_FIELD = "Email";

/** Minimum search term length required by `api/internal/impersonation`. */
export const MIN_USER_SEARCH_TERM_QUERY_LENGTH = 3;

export const searchableColumns: Array<{ name: string; value: string }> = [
    {
        name: "User ID",
        value: "UserId",
    },
    {
        name: "User email",
        value: "Email",
    },
    {
        name: "Email domain",
        value: "EmailDomain",
    },
    {
        name: "Account ID",
        value: "AccountId",
    },
    {
        name: "Zuora ID",
        value: "BillingAccountId",
    },
    {
        name: "CRM ID",
        value: "CrmId",
    },
    {
        name: "Account name",
        value: "AccountName",
    },
    {
        name: "Tenant ID",
        value: "TenantId",
    },
    {
        name: "API key",
        value: "ApiKey",
    },
];
